// window.Promise polyfill to use promise functionality
import 'es6-promise/auto';

// requestAnimationFrame + the other associated function
import 'requestanimationframe';

// css property: pointer-event:none
import 'pointer_events_polyfill/pointer_events_polyfill';
let PointerEventsPolyfill = require("exports-loader?PointerEventsPolyfill!pointer_events_polyfill/pointer_events_polyfill");
PointerEventsPolyfill.initialize({});



// WEBPACK FOOTER //
// ./src/app/utils/Pollyfills.ts